export default "__VITE_ASSET__Cg2sJBWj__"